module.exports = __webpack_public_path__ + "img/person3.7de04b5d.jpg";